import React, { ReactElement, ReactNode, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { Location, NavLink, Route, RouterProvider, createBrowserRouter, createRoutesFromElements, useLocation } from 'react-router-dom';
import Menu from '../Componentes/Menu'
import Toolbar from '../Componentes/Toolbar'
import Dispositivos from './Dispositivos';

interface Props{
  children?:ReactElement;
  isToolbarActive:boolean;
  hamburguesa:boolean;
  handleHamburguesa:(isActive:boolean)=>void;
}

const Principal = (props:Props) => {
  
  //const [hamburguesa, setHamburguesa] = useState(false);
  //const navigate = useNavigate();
  const visibleToolbar = (estado:boolean)=>{
    //setIsToolbarActive(estado)
  }
  return (
    <>
      {props.isToolbarActive &&
      <Toolbar hamburguesa={props.hamburguesa} handleHamburguesa={props.handleHamburguesa}/>} 
      
      {props.children}
    </>
  )
}

export default Principal
